import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/verify-email-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { resendVerificationEmail, verifyEmail } from '../../api/profile.ts';

function VerifyEmail() {
  const { token } = useParams();

  const auth = useAuth();

  const [isLoading, setIsLoading] = useState(true);
  const [isErrored, setIsErrored] = useState(false);
  const [hasResentEmail, setHasResentEmail] = useState(false);

  const handleResendEmail = () => {
    setHasResentEmail(true);
    setIsLoading(true);

    resendVerificationEmail(auth.id, token!)
      .then(() => {
        setIsErrored(false);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error resending verification email', JSON.stringify(error));
        setIsErrored(true);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    verifyEmail(token!)
      .then(() => {
        setIsErrored(false);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error verifying email address', JSON.stringify(error));
        setIsErrored(true);
        setIsLoading(false);
      });
  }, [token]);

  return (
    <Screen
      isLoading={isLoading}
      isErrored={isErrored}
      handleResendEmail={handleResendEmail}
      hasResentEmail={hasResentEmail}
    />
  );
}

export default VerifyEmail;
